import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AppContext";
import { Logo } from "../components/shared/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const raw = hash.startsWith("#") ? hash.slice(1) : hash;
    const params = new URLSearchParams(raw);
    const sid = params.get("session_id");
    if (!sid) { navigate("/"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        if (data.session_token) localStorage.setItem("session_token", data.session_token);
        window.history.replaceState(null, "", window.location.pathname);

        const u = data.user;
        if (!u.role) return navigate("/select-role", { replace: true });
        if (!u.onboarding_complete && u.role === "student") return navigate("/student/onboarding", { replace: true });
        if (!u.onboarding_complete && u.role === "company") return navigate("/company/onboarding", { replace: true });
        navigate(`/${u.role}`, { replace: true });
      } catch (e) {
        setErr("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/auth"), 1600);
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: "var(--bg)" }}>
      <Logo/>
      <div className="mt-8 flex items-center gap-2 text-sm text-zinc-400">
        {err ? err : (<><Loader2 size={14} className="animate-spin"/> Signing you in securely…</>)}
      </div>
    </div>
  );
}
